// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39cUu","right":"styles_right__VWJ5U"};